import React, {useEffect} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import Modal from "components/modal"
import Routes from "shared/routes"
import setLayout from "shared/set-layout"
import StripeForm from "components/stripe/form"
import {Text} from "shared/base"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useQueryParams from "on-location-changed/build/use-query-params"
import UtilsButton from "components/utils/button"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesCreditCard extends ShapeComponent {
  setup() {
    setLayout("front")

    const {t} = useI18n({namespace: "js.routes.add_credit_card"})
    const queryParams = useQueryParams()
    const mode = queryParams.add_credit_card == "success" ? "processing" : "form"

    this.setInstance({t})
    this.useStates({mode})

    useEffect(() => {
      if (queryParams.add_credit_card == "success") {
        void this.tt.onCreditCardAdded({queryParams})
      }
    }, [queryParams.add_credit_card])
  }

  render() {
    const {mode} = this.s

    return (
      <View dataSet={{route: "add-credit-card"}} style={{padding: 20}}>
        <Modal>
          {mode == "form" &&
            <StripeForm returnUrl={Routes.addCreditCardUrl({add_credit_card: "success"})} />
          }
          {mode == "processing" &&
            <View testID="add-credit-card/processing">
              <Text>
                {this.t("js.shared.loading")}
              </Text>
            </View>
          }
          {mode == "success" &&
            <>
              <Text>
                {this.t(".thank_you_for_adding_your_credit_card")}
              </Text>
              <UtilsButton onPress={this.tt.onCloseWindowPressed} title={this.t(".click_here_to_close_the_window")} />
            </>
          }
        </Modal>
      </View>
    )
  }

  /** @returns {Promise<void>} */
  onCreditCardAdded = async ({queryParams}) => {
    if (window.opener?.onSuccessfullCallback) {
      await window.opener.onSuccessfullCallback({queryParams})
    }

    this.setState({mode: "success"})
    window.close()
  }

  onCloseWindowPressed = () => window.close()
}))
